import { ValueInput } from './ValueInput'
import { ValueSelector } from './ValueSelector'

import type { ValueSelectProps } from './types'

export const ValueSelect = (props: ValueSelectProps) => {
    if (props.type === 'input') {
        const { type, ...restProps } = props
        void type

        return <ValueInput {...restProps} />
    }

    const { type, ...restProps } = props
    void type

    return <ValueSelector {...restProps} />
}
